
import Navbar from "../Navbar";
import Footer from "../Footer";
// import "../hamcss/directer.css";
// import ReactWhatsapp from "react-whatsapp";
import { FloatingWhatsApp } from 'react-floating-whatsapp';

import tech from '../../assests/tech.webp';
import Fin from '../../assests/fin.jpg';

import DotRing from '../../component/dot/DotRing';






const DeetailsOfBusiness = () => {
    return (
        <>

            <section style={{ display: 'flex', justifyContent: 'center' }}>
                <section className="containner">
                    <DotRing />
                    <div className="main_about_sg-fin">
                        <Navbar />

                        {/* <!--start banner slider--> */}
                        <section>
                            <div
                                className="BreadArea"
                                style={{
                                    backgroundImage: `url('/images/Bread.png')`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    height: "43vh",
                                }}
                            >
                                <div
                                    data-aos="fade-down"
                                    data-aos-duration="1000"
                                    style={{ marginTop: "30px" }}
                                    className="container"
                                >
                                    <h2 style={{ wordSpacing: '1px', letterSpacing: '0.2px' }}>
                                        Details of Business
                                    </h2>

                                </div>
                            </div>
                        </section>


                        <section className="about-element">
                            <div style={{ textAlign: 'center' }}>
                                <div data-aos="zoom-in" data-aos-duration='800' className="about-element-text about-text-box">
                                    <h2 style={{ wordSpacing: '1px', letterSpacing: '0.2px' }}>
                                        Details of Business

                                    </h2>
                                    {/*<h5 style={{ wordSpacing: "2px", wordBreak: 'break-all', letterSpacing: '0.2px' }}>
                                        Streamlining the Supply Chain Financing and optimizing the working capital cycle,
                                        ensuring Financial Inclusion for Indian MSMEs by all-round use of technology.
                                    </h5>*/}
                                    <p
                                        style={{
                                            paddingTop: "20px",
                                            marginTop: "20px",
                                            borderTop: "3px solid #f18620",
                                            wordSpacing: '2px',
                                            wordBreak: 'break-all',
                                            letterSpacing: '0.2px'

                                        }}
                                    >
                                        The Company operates as an integrated financing partner for dealers, distributors, retailers, vendors, and suppliers associated with leading Indian corporates. Its key offerings include dealer and distributor finance, vendor finance, channel finance, factoring, Trade Receivables Discounting System (TReDS), invoice financing, and other working capital facilities. The Company also provides diversified financing solutions, including loans against property (LAP), business loans, and digital lending products, to address the broader financing requirements of businesses.

SGFL's differentiated strength lies in its digitally native operating model, supported by an integrated technology platform that digitises the entire lending lifecycle, from customer onboarding and credit assessment to disbursement and loan monitoring. Direct integration with the ERP systems of anchor corporates facilitates end-use monitoring, faster turnaround times, and scalable, high-velocity operations. With a pan-India presence across 30 locations and established relationships with approximately 50 leading corporates, including the Tata Group, Adani Group, JSW Group, Vedanta Limited, and Mahindra & Mahindra, SGFL leverages its anchor-led business model to serve a diverse borrower base and facilitate timely access to financing. Through its technology-driven approach and diversified lending solutions, the Company aims to strengthen supply chain ecosystems, support business growth, and enhance access to efficient and flexible financing solutions.
                                    </p>


                                    <div className="tech-solution">
                                        <div data-aos="zoom-in" data-aos-duration='800' className="tech-solution-inside" >

                                            <h2 style={{ wordSpacing: "2px", wordBreak: 'break-all', marginTop: '20px', letterSpacing: '0.2px' }}>Technology Solutions</h2>
                                            <img src={tech} style={{ marginTop: '25px', width: '300px' }} alt="Technology Solutions" />
                                            <p style={{
                                                paddingTop: '10px',
                                                wordSpacing: '2px',
                                                wordBreak: 'break-all',
                                                letterSpacing: '0.2px'

                                            }}>
                                                Our supply chain financing solutions can leverage our partners all the benefits of advanced technology without incurring any capital outlay or maintenance costs. We also enable digital transformation and help businesses streamline their operations for optimal efficiency.
                                            </p>

                                        </div>

                                        <div data-aos="zoom-in" data-aos-duration='800' className="tech-solution-inside" >

                                            <h2 style={{ wordSpacing: "2px", wordBreak: 'break-all', marginTop: '20px', letterSpacing: '0.2px' }}>Financing Services</h2>

                                            <img src={Fin} style={{ marginTop: '20px', width: '300px' }} alt="Financing Solutions" />


                                            <p style={{
                                                paddingTop: '30px',
                                                wordSpacing: '2px',
                                                wordBreak: 'break-all',
                                                letterSpacing: '0.2px'

                                            }}>Our money lending and factoring services empowers MSMEs to unlock their cash flow potential and take control of their finances. By unlocking capital, we enable businesses to invest in growth and build a thriving enterprise that drives success.</p>

                                        </div>
                                    </div>


                                </div>


                                <div>
                                    {/* <ReactWhatsapp number="+919791028585" message="Hello World!!!" /> */}
                                    <FloatingWhatsApp phoneNumber="919791028585" accountName="Customer care" />
                                </div>


                                <Footer />
                            </div>
                        </section>
                    </div>
                </section>
            </section>
        </>
    )
}

export default DeetailsOfBusiness